import React from 'react';
import PropTypes from 'prop-types';

import { useClassNames } from 'components/pure/hooks';

const propTypes = {
  expanded: PropTypes.bool,
  uncontrolled: PropTypes.bool,
}

const defaultProps = {
  expanded: false,
  uncontrolled: true,
}

const classNames = {
  default: 'formBuilder__fieldTagWrapper d-flex',
  expanded: 'formBuilder__fieldTagWrapper--expanded',
  uncontrolled: 'formBuilder__fieldTagWrapper--uncontrolled'
}

export default function FieldTips({ children, className, expanded, uncontrolled, ...props }) {
  className = useClassNames(className, classNames, { expanded, uncontrolled })

  return <div {...props} className={className}>
    {children}
  </div>
}

FieldTips.propTypes = propTypes
FieldTips.defaultProps = defaultProps